import {hpcAttrs} from '@github-ui/hpc'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {ShowModelPayload} from '../../../types'
import {testIdProps} from '@github-ui/test-id-props'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'

export function Transparency() {
  const {modelTransparencyContent} = useRoutePayload<ShowModelPayload>()

  return (
    <VerifiedHTMLDiv
      {...hpcAttrs()}
      className="tmp-p-3"
      html={modelTransparencyContent}
      {...testIdProps('transparency-content')}
    />
  )
}
